// extracted by mini-css-extract-plugin
export default {"inner":"VendorButton-module--inner--424a2"};